import { render, staticRenderFns } from "./SavedBannersList.vue?vue&type=template&id=4ed4a594&scoped=true"
import script from "./SavedBannersList.vue?vue&type=script&lang=js"
export * from "./SavedBannersList.vue?vue&type=script&lang=js"
import style0 from "./SavedBannersList.vue?vue&type=style&index=0&id=4ed4a594&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ed4a594",
  null
  
)

export default component.exports